import loadable from '@utils/loadable';

import withComponentName from '../../decorators/withComponentName';

import Styles from './styles.module.scss';

const LanguagesTableComponent = loadable(() => import('./LanguagesTableComponent'));

const LanguageComponent = () => (
  <div className={Styles.language_container}>
    <div className={Styles.language_table}>
      <LanguagesTableComponent />
    </div>
    <div className={Styles.language_text}>
      <h3 className={`${Styles.title} text-uppercase`}>language is no longer a barrier</h3>
      <ul className={Styles.language_list}>
        <li className={Styles.list_item}>
          20+ languages: English, Spanish, German, French, Portuguese, Italian and more.
        </li>
        <li className={Styles.list_item}>
          Global and Local coverage: in addition to major publications,
          we also cover local sources to give you the full picture.
        </li>
      </ul>
    </div>
  </div>
);

export default withComponentName(LanguageComponent);
